import { render, staticRenderFns } from "./Pruebas.vue?vue&type=template&id=547d1e09&scoped=true&"
import script from "./Pruebas.vue?vue&type=script&lang=js&"
export * from "./Pruebas.vue?vue&type=script&lang=js&"
import style0 from "./Pruebas.vue?vue&type=style&index=0&id=547d1e09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d1e09",
  null
  
)

export default component.exports